import { callService } from '../../../Service/ServiceBase';
import { RequestType } from '../../../Service/RequestType';
import { PagedData } from '../../Common/CommonModel';
import {
  ClientSecretMetaData,
  ClientSecret,
  MessageGroup,
  UserMessageGroup,
  UserProfileMessage,
  PublishApiKeyParameters,
} from '../ClientSecrete/Model/ClientSecretesModel';

class ClientSecretService {
  // POST api/clientsecret/{customerId}/clientsecret
  async storeClientSecret(
    customerId: string,
    params: PublishApiKeyParameters,
  ): Promise<ClientSecret> {
    const route = `${customerId}/clientsecret`;
    const result = await callService(
      'clientsecret',
      route,
      RequestType.POST,
      params,
    );
    return result;
  }

  // GET api/clientsecret/{customerId}/clientsecrets
  async getClientSecretMetadata(
    customerId: string,
  ): Promise<PagedData<ClientSecretMetaData>> {
    const route = `${customerId}/clientsecrets`;
    const result = await callService('clientsecret', route, RequestType.GET);
    return result;
  }

  // PUT api/clientsecret/{customerId}/clientsecrets/activateorinactivate/{clientId}/{isActive}
  async updateClientActiveness(
    customerId: string,
    clientId: string,
    isActive: boolean,
  ): Promise<boolean> {
    const route = `${customerId}/clientsecrets/activateorinactivate/${clientId}/${isActive}`;
    const result = await callService('clientsecret', route, RequestType.PUT);
    return result;
  }

  // PUT api/clientsecret/{customerId}/clientsecret/clientid/{clientId}
  async refreshSecret(
    customerId: string,
    clientId: string,
  ): Promise<ClientSecret> {
    const route = `${customerId}/clientsecret/clientid/${clientId}`;
    const result = await callService('clientsecret', route, RequestType.PUT);
    return result;
  }

  // GET api/clientsecret/{customerId}/clientsecret/profiles/available
  async getAvailableProfiles(
    customerId: string,
    pageNo: number,
  ): Promise<PagedData<UserProfileMessage>> {
    const route = `${customerId}/profiles/available?pageNo=${pageNo}`;
    const result = await callService('clientsecret', route, RequestType.GET);
    return result;
  }

  // GET api/clientsecret/{customerId}/clientsecret/clientid/{clientId}/groups/available
  async getAvailableGroups(
    customerId: string,
    clientId: string,
    pageNo: number,
  ): Promise<PagedData<MessageGroup>> {
    const route = `${customerId}/clientsecret/clientid/${clientId}/groups/available?pageNo=${pageNo}`;
    const result = await callService('clientsecret', route, RequestType.GET);
    return result;
  }

  // POST api/clientsecret/{customerId}/clientsecret/clientid/{clientId}/groups
  async addGroupsToClient(
    customerId: string,
    clientId: string,
    clientGroups: MessageGroup[],
  ): Promise<string> {
    const route = `${customerId}/clientsecret/clientid/${clientId}/groups`;
    const result = await callService(
      'clientsecret',
      route,
      RequestType.POST,
      clientGroups,
    );
    return result;
  }

  // GET api/clientsecret/{customerId}/clientsecret/clientid/{clientId}/groups
  async getClientGroups(
    customerId: string,
    clientId: string,
    pageNo: number,
  ): Promise<PagedData<UserMessageGroup>> {
    const route = `${customerId}/clientsecret/clientid/${clientId}/groups?pageNo=${pageNo}`;
    const result = await callService('clientsecret', route, RequestType.GET);
    return result;
  }

  // GET api/clientsecret/{customerId}/clientsecret/clientid/{clientId}/groups/available/count
  async getAvailableGroupsCount(
    customerId: string,
    clientId: string,
  ): Promise<number> {
    const route = `${customerId}/clientsecret/clientid/${clientId}/groups/available/count`;
    const result = await callService('clientsecret', route, RequestType.GET);
    return result;
  }

  // GET api/clientsecret/{customerId}/clientsecret/clientid/{clientId}/groups/count
  async getClientGroupsCount(
    customerId: string,
    clientId: string,
  ): Promise<number> {
    const route = `${customerId}/clientsecret/clientid/${clientId}/groups/count`;
    const result = await callService('clientsecret', route, RequestType.GET);
    return result;
  }

  // DELETE api/clientsecret/{customerId}/clientsecret/clientid/{clientId}/groups
  async removeGroupsFromClient(
    customerId: string,
    clientId: string,
    clientGroups: number[],
  ): Promise<PagedData<UserMessageGroup>> {
    const route = `${customerId}/clientsecret/clientid/${clientId}/groups`;
    const result = await callService(
      'clientsecret',
      route,
      RequestType.DELETE,
      clientGroups,
    );
    return result;
  }

  // GET api/clientsecret/{customerId}/clientsecret/clientid/{clientId}/groups/search
  async searchAvailableGroups(
    customerId: string,
    clientId: string,
    searchString: string,
    pageNo: number,
  ): Promise<PagedData<MessageGroup>> {
    const route = `${customerId}/clientsecret/clientid/${clientId}/groups/search?searchString=${encodeURIComponent(searchString)}&pageNo=${pageNo}`;
    const result = await callService('clientsecret', route, RequestType.GET);
    return result;
  }
}

export const clientsecretService: ClientSecretService =
  new ClientSecretService();
